import Vue from "vue";
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import ar from "vuetify/lib/locale/ar";

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {
            customProperties: true
        },
        themes: {
            light: {
                primary: "#ee44aa",
                secondary: "#424242",
                accent: "#82B1FF",
                error: "#FF5252",
                info: "#2196F3",
                success: "#4CAF50",
                warning: "#FFC107",

                IMThemeGray: "#3E3E3E",
                IMThemeOrange: "#FF5F01",
                gray: "#E9E8E8",
                
                white: "#fff",
                light: "#F8F8F8"
            }
        }
    },
    lang: {
        locales: { ar },
        current: "ar"
    },
    rtl: true
});
